import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

let nextId = 0;

@Component({
	selector: 'xp-dialog-header',
	standalone: true,
	imports: [NgIf, MatButtonModule, MatIconModule],
	templateUrl: './xp-dialog-header.component.html',
	styleUrls: ['./xp-dialog-header.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class XpDialogHeaderComponent {
	heading = input('');
	subheading = input('');
	closeLabel = input('Close');
	closeClick = output<void>();

	readonly headingId = `xp-dialog-header-title-${nextId++}`;
}
